import { isCollectionVariant } from '@ikegps/core-api';
import { CurrentState } from '../../state/page.state';

/**
 * Poles created in Verify are read-only variants and are not eligible for collection actions
 * (duplicate, set status, update form, migrate form). An action is offered only when the selection
 * contains no variant.
 */
export function selectionExcludesVariants(): boolean {
	return !CurrentState.Tag.collections.some((collection) => isCollectionVariant(collection));
}
